/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var toggleForm = require('common/util/toggleForm');
var modelGet = require('common/util/modelGet');
var parsleyUtil = require('common/util/parsleyUtil');

var tmplDebtSettlementServicesAnnualReportVolumeAndRetentionSectionView = require('./DebtSettlementServicesAnnualReportVolumeAndRetentionSectionView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDebtSettlementServicesAnnualReportVolumeAndRetentionSectionView,

  className: 'debt-settlement-services-annual-report-production-report-section-view',

  behaviors: {
    RadioGroupToggleBehavior: {
      radios: [
        {
          target: '#isSufficientExplanationArea',
          radioGroup: '[name="isSufficient"]',
          valueToShow: '0'
        }
      ]
    }
  },

  ui: {
    volumeAndRetentionForm: '.volume-and-retention-form',
    notAvailable: '.not-available',
    numBeginningEnrolledInputs: '#numBeginningEnrolledInputs',
    numBeginningEnrolledExplanation: '#numBeginningEnrolledExplanation',
    numSignedUpInputs: '#numSignedUpInputs',
    numSignedUpExplanation: '#numSignedUpExplanation',
    numCompletedInputs: '#numCompletedInputs',
    numCompletedExplanation: '#numCompletedExplanation',
    numDroppedOutAfterThreeMonthsInputs: '#numDroppedOutAfterThreeMonthsInputs',
    numDroppedOutAfterThreeMonthsExplanation: '#numDroppedOutAfterThreeMonthsExplanation',
    numDroppedOutBeforeThreeMonthsInputs: '#numDroppedOutBeforeThreeMonthsInputs',
    numDroppedOutBeforeThreeMonthsExplanation: '#numDroppedOutBeforeThreeMonthsExplanation',
    numEnrolledInputs: '#numEnrolledInputs',
    numEnrolledExplanation: '#numEnrolledExplanation',
    numDeniedInputs: '#numDeniedInputs',
    numDeniedExplanation: '#numDeniedExplanation'
  },

  events: {
    'change @ui.notAvailable': 'onChangeNotAvailable'
  },

  onBeforeShow: function() {
    var numBeginningEnrolledNotAvailable = modelGet(this.model, 'annualReport.numBeginningEnrolledNotAvailable');
    this.toggleQuestionInputs(this.ui.numBeginningEnrolledInputs, numBeginningEnrolledNotAvailable);
    this.toggleExplanationInputs(this.ui.numBeginningEnrolledExplanation, numBeginningEnrolledNotAvailable);

    var numSignedUpNotAvailable = modelGet(this.model, 'annualReport.numSignedUpNotAvailable');
    this.toggleQuestionInputs(this.ui.numSignedUpInputs, numSignedUpNotAvailable);
    this.toggleExplanationInputs(this.ui.numSignedUpExplanation, numSignedUpNotAvailable);

    var numCompletedNotAvailable = modelGet(this.model, 'annualReport.numCompletedNotAvailable');
    this.toggleQuestionInputs(this.ui.numCompletedInputs, numCompletedNotAvailable);
    this.toggleExplanationInputs(this.ui.numCompletedExplanation, numCompletedNotAvailable);

    var numDroppedOutAfterThreeMonthsNotAvailable = modelGet(
      this.model,
      'annualReport.numDroppedOutAfterThreeMonthsNotAvailable'
    );
    this.toggleQuestionInputs(this.ui.numDroppedOutAfterThreeMonthsInputs, numDroppedOutAfterThreeMonthsNotAvailable);
    this.toggleExplanationInputs(
      this.ui.numDroppedOutAfterThreeMonthsExplanation,
      numDroppedOutAfterThreeMonthsNotAvailable
    );

    var numDroppedOutBeforeThreeMonthsNotAvailable = modelGet(
      this.model,
      'annualReport.numDroppedOutBeforeThreeMonthsNotAvailable'
    );
    this.toggleQuestionInputs(this.ui.numDroppedOutBeforeThreeMonthsInputs, numDroppedOutBeforeThreeMonthsNotAvailable);
    this.toggleExplanationInputs(
      this.ui.numDroppedOutBeforeThreeMonthsExplanation,
      numDroppedOutBeforeThreeMonthsNotAvailable
    );

    var numEnrolledNotAvailable = modelGet(this.model, 'annualReport.numEnrolledNotAvailable');
    this.toggleQuestionInputs(this.ui.numEnrolledInputs, numEnrolledNotAvailable);
    this.toggleExplanationInputs(this.ui.numEnrolledExplanation, numEnrolledNotAvailable);

    var numDeniedNotAvailable = modelGet(this.model, 'annualReport.numDeniedNotAvailable');
    this.toggleQuestionInputs(this.ui.numDeniedInputs, numDeniedNotAvailable);
    this.toggleExplanationInputs(this.ui.numDeniedExplanation, numDeniedNotAvailable);

    Syphon.deserialize(this, this.model.get('annualReport'));
  },

  onChangeNotAvailable: function(e) {
    var $checkbox = $(e.target);
    var isNotAvailable = $checkbox.prop('checked');
    var formTargetSelector = $checkbox.attr('data-target');
    var $questionInputs = this.$el.find(formTargetSelector + 'Inputs');
    var $explanationInputs = this.$el.find(formTargetSelector + 'Explanation');
    this.toggleQuestionInputs($questionInputs, isNotAvailable);
    this.toggleExplanationInputs($explanationInputs, isNotAvailable);
  },

  validate: function(config) {
    if (config.type === 'save') {
      parsleyUtil.disableRequiredValidation(this.ui.volumeAndRetentionForm);
    } else {
      parsleyUtil.enableRequiredValidation(this.ui.volumeAndRetentionForm);
    }
    return this.ui.volumeAndRetentionForm.parsley().whenValidate();
  },

  getFormData: function() {
    return Syphon.serialize(this);
  },

  toggleQuestionInputs: function($element, isNotAvailable) {
    toggleForm($element, !isNotAvailable);
  },

  toggleExplanationInputs: function($element, isAvailable) {
    toggleForm($element, isAvailable);
  }
});
